import React from 'react'
import styled from 'styled-components'
import $ from "jquery";
import OtpInputCard from "otp-input-react";
import Countdown from 'react-countdown-now';

import Layout from '../../components/Layout'
import ProgressBar from '../../components/ProgressBar';
import Button from '../../components/Button'
import Modal from '../../components/Modal'

import constants from '../../config/constants'

const Main = styled.div`
  padding-top: 2rem;
`

const MainDetail = styled.div`
  .ant-input {
    color: ${constants.color.dark} !important;
    border: 1px solid ${constants.color.lightDark} !important;
    line-height: 24.3px !important;
    caret-color: ${constants.color.blue} !important;

    &::placeholder {
      color: ${constants.color.lightDark} !important;
    }

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }
  }

  .ant-form-item-required::before {
    content: '' !important;
    margin-right: 0 !important;
  }

  .ant-form-item-label > label {
    font-family: 'Thonburi';
    color: ${constants.color.mediumDark} !important;
  }

  .ant-form-item-control {

    .ant-form-extra {
      font-size: 12px !important;
    }
  }

  .has-error .ant-form-explain, .has-error .ant-form-split {
    color: ${constants.color.red} !important;
  }
`

const Description = styled.p`
  color: ${constants.color.mediumDark};
`

const MainModal = styled.div`
  text-align: center;
  padding: 0 15px;
`

const ModalDetail = styled.p`
  color: ${constants.color.mediumDark};
`

const OtpInput = styled(OtpInputCard)`
  input {
    caret-color: ${constants.color.darkBlue} !important;
  }
  input.bottom__border.has-value {
      border-bottom-color: ${constants.color.darkBlue} !important;
  }
  input.bottom__border:focus {
      border-bottom-color: ${constants.color.darkBlue} !important;
  }
  input.bottom__border::selection {
      color: ${constants.color.mediumDark};
      background: ${constants.color.white};
  }
`

const RefOTP = styled.p`
  color: ${constants.color.mediumDark};
  margin: 1rem 0;
  text-align: center;
`

const Error = styled.div`
  margin: 2rem 0 0;
  font-size: 14px;
  line-height: 18.9px;
  color: ${constants.color.red};
`

const ResendOTP = styled.p`
  color: ${constants.color.blue};
  margin: 1rem 0 0;
  text-align: center;

  span {
    margin: 0 .3rem;
  }
`

class OtpConfirmEmail extends React.Component {

  state = {
    disabled: false,
    otp: null,
    openModal: false,
    error: false,
    countdown: false,
    time: 0,
    countWrong: 0
  };

  setOTP = (event) => {
    $.when(
      $('input').each((x,element) => {
        if($(element).val() !== '') {
          $(element).addClass('has-value');
          if(this.state.otp === event) {
            $(element).eq(x+2).focus();
            event = event.substring(0, event.length - 1);
          }
          this.setState({ error: false, otp : event })
        } else {
          $(element).val('');
          $(element).removeClass('has-value');
        }
      })
    ).then(() => {
      if(event.length === 8) {
        setTimeout(() => {
          this.checkValue(event);
        }, 300)
      }
    })
  }

  checkValue = (value) => {
    if(value === '00000000') {
      if(this.state.countWrong < 2) {
        this.setState({ countWrong: this.state.countWrong + 1})
        this.setState({ error: true, otp: null});
        this.clearValue()
      } else {
        this.setState({ error: false, openModal: true, countdown: true, time: 60000, otp: null,disabled : true})
        setTimeout(() => {
          this.setState({ disabled : false , time: 0, countWrong: 0});
          $('input:first').focus();
        }, 60000);
      }
    } else {
      this.props.history.push('/confirm-email-success');
    }
  }

  onClickResendOTP = () => {
    if(this.state.countdown === false) {
      this.setState({ countdown: !this.state.countdown, time: 10000});
    }
  }

  countdownTimeRenderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      this.setState({ countdown: !this.state.countdown, time: 0});
      return ''
    } else {
      return <span>{minutes}:{seconds}</span>;
    }
  };

  hendelCloseModal = () => {
    this.setState({ openModal: !this.state.openModal})
    this.clearValue()
  }

  clearValue = () => {
    $('input').each((x,element) => {
      $('input:first').focus();
      $(element).removeClass('has-value');
    })
  }


  render () {

    return (
      <Layout title={'ข้อมูลส่วนตัว'} backIcon={true} onClick={() => this.props.history.push('/confirm-email')}>
        <ProgressBar percent={25}/>
        <Main>
          <MainDetail>
            <h4>ยืนยันอีเมล</h4>
            <Description>ระบบได้ส่งรหัสตัวเลข 8 หลักไปยังอีเมลของคุณโปรดกรอกรหัสดังกล่าวในช่องด้านล่างเพื่อยืนยันอีเมล</Description>
            <OtpInput
                  title="Input styling with inputStyles prop"
                  inputClassName="bottom__border"
                  autoFocus
                  OTPLength={8}
                  otpType="number"
                  disabled={this.state.disabled}
                  onChange={this.setOTP.bind(this)}
                  value={this.state.otp}
                  inputStyles={{
                      border: 0,
                      borderBottom: `2px solid ${constants.color.lightDark}`,
                      outline: "none",
                      margin: "0 auto",
                      borderRadius: "1px",
                      fontSize: "20px"
                  }}
              />
              <RefOTP>
                Ref OTP code: KSOWAV
                <Error>
                  {this.state.error && "รหัสยืนยันไม่ถูกต้อง กรุณาตรวจสอบและกรอกอีกครั้ง"}
                </Error>
              </RefOTP>
              <ResendOTP onClick={this.onClickResendOTP}>
                ขอรหัสยืนยันใหม่
                { this.state.countdown &&
                  <Countdown
                    date={Date.now() + this.state.time}
                    renderer={this.countdownTimeRenderer.bind(this)}
                  />
                }
              </ResendOTP>
          </MainDetail>
        </Main>
        <Modal visible={this.state.openModal}>
          <MainModal>
            <h4>ไม่สามารถกรอกรหัสยืนยันได้</h4>
            <ModalDetail>คุณกรอกรหัสยืนยันไม่ถูกต้อง<br/>เกินจำนวนครั้งที่กำหนด<br/>กรุณาทำรายการใหม่ใน 1 นาที</ModalDetail>
            <Button
              textcolor={constants.color.white}
              bordercolor={constants.color.orange}
              backgroundcolor={constants.color.orange}
              text={'ตกลง'}
              disabled={false}
              onClick={this.hendelCloseModal.bind(this)}/>
          </MainModal>
        </Modal>
      </Layout>
    )
  }
}

export default OtpConfirmEmail
